module.exports = __webpack_public_path__ + "static/media/airbnbPrice.6f6406af.jpg";